import type {ReactElement} from 'react';
import type {BrandColor, BrandContent} from '@Components/editor-brands/editor-brands.types';
import {ColorFill} from '@Components/color-fill';
import {useAppSelector} from '@/hooks';
import styles from './brand-colors.module.scss';
import {hexToRgba} from '@Utils/color.util';

const DEFAULT_COLOR_FILL_WIDTH = 40;
const DEFAULT_COLOR_FILL_HEIGHT = 40;

export interface BrandColorsProps {
  onAddColor(color: string): void;
}

function BrandColors({...props}: BrandColorsProps): ReactElement<any> {
  const activeBrandId: string = useAppSelector((state) => {
    return state.brands.activeBrandId ?? '';
  });
  const brandContent: Record<string, BrandContent> = useAppSelector((state) => {
    return state.brands.brandContent;
  });
  const brandColors: Record<string, BrandColor> = useAppSelector((state) => {
    return state.brands.colors;
  });

  const onAddColor = (color: string): void => {
    props.onAddColor(color);
  };

  const getBrandColorContent = (): ReactElement<any>[] => {
    return brandContent[activeBrandId].colors.ids.map((id) => {
      return (
        <ColorFill
          key={brandColors[id].idbrandColor}
          color={hexToRgba(brandColors[id].hexCode)}
          width={DEFAULT_COLOR_FILL_WIDTH}
          height={DEFAULT_COLOR_FILL_HEIGHT}
          onClick={(): void => {
            onAddColor(brandColors[id].hexCode);
          }}
        />
      );
    });
  };

  return <div className={`flexbox spacing-p-t-3 ${styles.colorFill}`}>{getBrandColorContent()}</div>;
}

export default BrandColors;
